import { CircularProgress, Stack, Typography } from '@mui/material';

import { useGetDocumentDataQuery } from '@/modules/files/hooks/graphql/UseDocumentData.generated';

import { useDocumentChatContext } from '../contexts/DocumentChatProvider';
import { getQuestionsForDocumentType } from './DocumentChatEmptyState.utils';
import { DocumentChatSuggestion } from './DocumentChatSuggestion';

export function DocumentChatEmptyState() {
  const { documentId } = useDocumentChatContext();

  const { data, loading } = useGetDocumentDataQuery({
    variables: { documentId: documentId ?? '' },
    skip: !documentId,
  });

  const documentType =
    data?.node?.__typename === 'Document' ? data.node.type : null;

  const questions = getQuestionsForDocumentType(documentType);

  return (
    <Stack
      sx={{
        flexGrow: 1,
        gap: 2,
        px: 2,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack
        sx={{
          gap: 2,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="title-xs">What can I ask?</Typography>

        <Stack
          sx={{
            gap: 1,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : (
            questions.map((question) => (
              <DocumentChatSuggestion key={question} question={question} />
            ))
          )}
        </Stack>

        <Typography variant="body-xs" textAlign="center">
          History is cleared when you leave this page
        </Typography>
      </Stack>
    </Stack>
  );
}
